export default __webpack_public_path__ + "static/media/mahogany.f4c31160.JPG";